module.exports = __webpack_public_path__ + "c49ef5f0b4a10edd99476c3998c8c1b5.fbx";